export const Constants = {
    videoId: "dxDBXwRfs6Y",
    webUrl: process.env.REACT_APP_WEB_URL ?? "",
    frankenstoriesUrl: process.env.REACT_APP_FRANKENSTORIES_URL ?? "",
    googleOauthClientId: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID ?? "",
    gtm: process.env.REACT_APP_GTM_FRANKENSTORIES ?? "",
};
